import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ModalComponent} from '@app/shared/components/modal/modal.component';
import {EmdEmployee} from '@app/shared/models/emd-employee.model';
import {UserBusinessType} from '@app/shared/models/enums/user-business-type.enum';
import {SearchAutocompleteComponent} from '@app/shared/components/form/search-autocomplete/search-autocomplete.component';

@Component({
    selector: 'app-register-emd-user-modal',
    templateUrl: './register-emd-user-modal.component.html',
    styleUrls: ['./register-emd-user-modal.component.scss']
})
export class RegisterEmdUserModalComponent {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(SearchAutocompleteComponent) searchAutocomplete: SearchAutocompleteComponent;

    @Input() employees: EmdEmployee[] = [];
    @Input() userBusinessTypes = [];
    @Input() isRegistering = false;

    @Output() searchEmployees = new EventEmitter<string>();
    @Output() register = new EventEmitter<{ badgeId: number | null; userBusinessType: string }>();

    selectedEmployee: EmdEmployee;
    selectedUserBusinessType: UserBusinessType | null;

    open() {
        this.reset();
        this.modal.open();
    }

    close() {
        this.reset();
        this.modal.close();
    }

    onEmployeeSearch(searchTerm: string) {
        this.searchEmployees.emit((searchTerm || '').trim());
    }

    onEmployeeSelected(employee: EmdEmployee | null) {
        this.selectedEmployee = employee;
    }

    onRegister() {
        if (!this.canRegister) {
            return;
        }

        this.register.emit({
            badgeId: this.selectedEmployee?.badgeId ?? null,
            userBusinessType: UserBusinessType[this.selectedUserBusinessType]
        });
    }

    get canRegister() {
        return this.hasSelectedEmployee && !!this.selectedUserBusinessType;
    }

    get hasSelectedEmployee() {
        return !!this.selectedEmployee && (!!this.selectedEmployee.badgeId || !!this.selectedEmployee.badgeRfid);
    }

    onDismiss() {
        this.reset();
    }

    private reset() {
        this.searchAutocomplete?.reset();
        this.selectedEmployee = null;
        this.selectedUserBusinessType = null;
        this.searchEmployees.emit('');
    }
}
